import TwoFaStepperPage from './TwoFaStepperPage';
import TwoFaVerifyPage from './TwoFaVerifyPage';
import AuthPage from './AuthPage';
import CheckEmailPage from './CheckEmailPage';
import MagicLinkRedirectPage from './MagicLinkRedirectPage';
import TwoFaBackupCodePage from './TwoFaBackupCodePage';
import authRoles from '../../auth/authRoles';

const TwoFaConfig = {
    settings: {
        layout: {
            config: {
                navbar: {
                    display: false,
                },
                toolbar: {
                    display: false,
                },
                footer: {
                    display: false,
                },
                leftSidePanel: {
                    display: false,
                },
                rightSidePanel: {
                    display: false,
                },
            },
        },
    },
    auth: authRoles.onlyGuest,
    routes: [
        {
            path: 'enable-2fa',
            element: <TwoFaStepperPage />,
        },
        {
            path: 'auth/method',
            element: <AuthPage />,
        },
        {
            path: 'auth/check-email',
            element: <CheckEmailPage />,
        },
        {
            path: 'auth/magic-login',
            element: <MagicLinkRedirectPage />,
        },
        {
            path: 'verify-2fa',
            element: <TwoFaVerifyPage />,
        },
        {
            path: 'verify-backup-code',
            element: <TwoFaBackupCodePage />,
        },
    ],
};

export default TwoFaConfig;
